module.exports = __webpack_public_path__ + "img/BITZ.4020f943.svg";